window.AGAmerica = window.AGAmerica || {};

window.AGAmerica.AGAPageTransitionRegion = function ($, Behaviors, PageTransition, lottie) {
    "use strict";

    function next_loop_complete_promise(lottie_anim) {
        var promise = new Promise(function (resolve, reject) {
            function handler() {
                resolve();
                lottie_anim.removeEventListener("loopComplete", handler);
            }

            lottie_anim.addEventListener("loopComplete", handler);
        });

        return promise;
    }

    /**
     * Subclass/customization of `PageTransitionRegion` that also handles
     * Beaver Builder CSS.
     */
    function AGAPageTransitionRegion() {
        Behaviors.init(AGAPageTransitionRegion, this, arguments);

        if ($(document).width() >= 768 && window.location.pathname === "/") {
            this.$anim_elem = this.$elem.find("[data-aga-pagetransition-lottie]");
            if (this.$anim_elem.length > 0) {
                this.animation = lottie.loadAnimation({
                    container: this.$anim_elem[0],
                    renderer: 'svg',
                    loop: true,
                    autoplay: true,
                    path: '/wp-content/themes/beaverwarrior/components/PageTransition/dynamic_icon.json'
                });
            }

            this.animation.setSpeed(2.0);

            this.transition_loading().then(function () {
                this.transition_in().then(function () {
                    this.transition_done()
                }.bind(this));
            }.bind(this));
        } else {
            this.transition_in().then(function () {
                this.transition_done()
            }.bind(this));
        }
    }

    Behaviors.inherit(AGAPageTransitionRegion, PageTransition.PageTransitionRegion);

    AGAPageTransitionRegion.QUERY = "[data-aga-pagetransition-region]";

    /**
     * Copy head content (such as the title, or Beaver Builder CSS) into this
     * page.
     *
     * This extends the superclass's `replace_head` method.
     *
     * @param {window.jQuery} $new_document The document being replaced in,
     * without restriction to the region that is being replaced
     */
    AGAPageTransitionRegion.prototype.replace_head = function ($new_document) {
        PageTransition.PageTransitionRegion.prototype.replace_head.apply(this, arguments);

        var $head = $("head"),
            $new_css = $new_document.filter("link[rel='stylesheet'], style, script");

        $new_css.each(function (index, sheet_elem) {
            var $sheet_elem = $(sheet_elem),
                id = $sheet_elem.attr("id");

            if (id) {
                $("#" + id).remove();
            }
        });

        $head.append($new_css);
    }

    /**
     * Simulate navigation to a new page by animating out, downloading the
     * page, injecting it into the current document, and then animating in.
     *
     * This implementation removes the simulation step: we instead animate out
     * and just navigate to the new page. This guarantees that all JavaScript
     * will reset and get the events it expects, at the expense of every page
     * needing to start in the loading state and then animate themselves in.
     *
     * This function returns a Promise that will probably not resolve, as the
     * page load will now obliterate all existing event loop tasks.
     *
     * @param {string} url The URL to simulate navigation to
     * @param {bool} isPopState If we're going backwards.
     */
    AGAPageTransitionRegion.prototype.retrieve_document_by_url = function (url, isPopState) {
        return this.transition_out().then(function () {
            window.location = url;

            return Promise.resolve();
        }.bind(this));
    }

    /**
     * Determine what kind of link a particular element is.
     *
     * This is an improvement upon the base PageTransitionRegion impl that
     * tries to catch a handful of broken WordPress behaviors that misuse
     * anchors as buttons.
     *
     * @param {string} url The URL to navigate to
     * @param {window.jQuery} $a The link that was clicked
     * @returns One of the PageTransitionRegion constants, either
     * `LINK_INTERNAL`, `LINK_EXTERNAL`, `LINK_POPUP`, or `LINK_HASH`.
     */
    AGAPageTransitionRegion.prototype.is_internal_link = function (url, $a) {
        if (url === undefined || url === '') {
            return PageTransition.PageTransitionRegion.LINK_HASH;
        }

        return PageTransition.PageTransitionRegion.prototype.is_internal_link.apply(this, arguments);
    }

    AGAPageTransitionRegion.prototype.transition_out = function () {
        var aw;

        this.$elem.removeClass("is-PageTransition--transition_loading");
        this.$elem.addClass("is-PageTransition--transition_out");
        this.$elem.removeClass("is-PageTransition--transition_in");
        aw = new Animations.AnimationWatcher(this.$elem.find("[data-pagetransition-backdrop]"));

        if (this.animation) {
            this.animation.stop();
        }

        return aw.promise;
    };

    AGAPageTransitionRegion.prototype.transition_loading = function () {
        this.$elem.addClass("is-PageTransition--transition_loading");
        this.$elem.removeClass("is-PageTransition--transition_out");
        this.$elem.removeClass("is-PageTransition--transition_in");

        if (this.animation) {
            this.animation.goToAndPlay(0, true);

            return next_loop_complete_promise(this.animation);
        } else {
            return Promise.resolve();
        }
    };

    AGAPageTransitionRegion.prototype.transition_in = function () {
        var aw;

        this.$elem.removeClass("is-PageTransition--transition_loading");
        this.$elem.removeClass("is-PageTransition--transition_out");
        this.$elem.addClass("is-PageTransition--transition_in");
        aw = new Animations.AnimationWatcher(this.$elem.find("[data-pagetransition-backdrop]"));

        if (this.animation) {
            this.animation.stop();
        }

        return aw.promise;
    };

    Behaviors.register_behavior(AGAPageTransitionRegion);

    return AGAPageTransitionRegion;
}(window.jQuery, window.Behaviors, window.PageTransition, window.lottie);